import React from 'react';
import './styles/Header.css';

const Header = React.forwardRef((props, ref) => {
	return (
		<>
			<header ref={ref} className="mx-auto">
				<div id="header" className="container">
					<div className="img-and-title">
						<img
							className="rounded-circle"
							src="https://i.imgur.com/3xRwD5E.png"
							alt="Mert Toprak"
						/>
						<h2 className="mx-auto">
							Hi, my name is <h1 className="typewriter">Mert Toprak.</h1>
						</h2>
					</div>
					<div className="paragraphs">
						<p className="lead">
							Transitioning from a background in Maritime Business and
							Administration, I am embarking on a new journey in web
							development. With a fervent passion for coding and a commitment to
							mastering full-stack development, I am eager to leverage my skills
							in this dynamic field.
						</p>
						<br />
						<p className="lead">
							Driven by a desire for continuous growth, I am currently immersing
							myself in mastering full-stack development while embracing the
							vibrant culture of the Netherlands. My dedication to learning and
							adapting is evident in my recent collaboration with Turkcell,
							where I contributed to the creation of chatbots used by millions.
						</p>
						<br />
						<p className="lead">
							As I navigate this career transition, I am excited about the
							prospect of exploring opportunities in web development. With a
							strong foundation in problem-solving and a keen eye for detail, I
							am ready to tackle new challenges and contribute to innovative
							projects.
						</p>
						<br />
						<p className="lead">
							Let's connect to discuss how my passion for web development and
							drive for success can align with your team's goals.
						</p>
					</div>
					<div className="social-media-buttons">
						<a
							className="social-media-button btn btn-success"
							href="https://www.linkedin.com/in/mert-toprak/"
							target="_blank"
							rel="noreferrer"
						>
							<svg
								xmlns="https://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								stroke="white"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
								class="feather feather-linkedin"
							>
								<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
								<rect x="2" y="9" width="4" height="12"></rect>
								<circle cx="4" cy="4" r="2"></circle>
							</svg>
						</a>
						<a
							className="social-media-button btn btn-success"
							href="https://github.com/EminmertToprak"
							target="_blank"
							rel="noreferrer"
						>
							<svg
								xmlns="https://www.w3.org/2000/svg"
								width="20"
								height="20"
								fill="currentColor"
								viewBox="0 0 24 24"
							>
								<path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
							</svg>
						</a>
						<a
							className="social-media-button"
							href="mailto:mert.tprk@gmail.com"
						>
							<svg
								xmlns="https://www.w3.org/2000/svg"
								width="256"
								height="193"
								viewBox="0 0 256 193"
							>
								<path
									fill="#4285F4"
									d="M58.182 192.05V93.14L27.507 65.077L0 49.504v125.091c0 9.658 7.825 17.455 17.455 17.455z"
								/>
								<path
									fill="#34A853"
									d="M197.818 192.05h40.727c9.659 0 17.455-7.826 17.455-17.455V49.505l-31.156 17.837l-27.026 25.798z"
								/>
								<path
									fill="#EA4335"
									d="m58.182 93.14l-4.174-38.647l4.174-36.989L128 69.868l69.818-52.364l4.669 34.992l-4.669 40.644L128 145.504z"
								/>
								<path
									fill="#FBBC04"
									d="M197.818 17.504V93.14L256 49.504V26.231c0-21.585-24.64-33.89-41.89-20.945z"
								/>
								<path
									fill="#C5221F"
									d="m0 49.504l26.759 20.07L58.182 93.14V17.504L41.89 5.286C24.61-7.66 0 4.646 0 26.23z"
								/>
							</svg>
						</a>
					</div>
				</div>
			</header>
		</>
	);
});

export default Header;
